import React from 'react';
import DataGrid from '@dataGrid';
import PickupInfoGridConfig from './GridConfig';
import { compose } from 'recompose';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import { withAppConfig } from '../../../../../../../../../appConfigContext';
import Events from '../../../../../../../../../utilities/EventEmitter';
import withRouter from '../../../../../../../../../routes/withRouter';

class PickupInfoGrid extends React.Component {
  constructor(props) {
    super(props);

    this.gridConfig = new PickupInfoGridConfig({
      showTrailerScac: this.props.configJSON.showTrailerScac
    });
    this.gridContext = { isPickupCompleted: this.isPickupCompleted };
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    Events.emit(`setGridApi`, { api, gridName: this.gridConfig.config.title });
  };

  isPickupCompleted = () => {
    return this.props.pickInfoStateData.pickupInfo.isCompleted;
  };

  constructStatusBar = () => {
    const { pieces, weight, bills, hu } = this.props.pickInfoStateData.pickupInfo;
    const { classes } = this.props;
    const data = [
      { label: 'Pieces', value: pieces },
      { label: 'Weight', value: weight },
      { label: 'HUs', value: hu },
      { label: 'Shipments', value: bills }
    ];
    return (
      <div className={classes.GridFooter}>
        <div className={classes.value}>Total</div>
        {data.map(({ label, value }, index) => (
          <div key={index}>
            <span className={classes.label}>{label}:</span>
            <span className={classes.value}>{value}</span>
          </div>
        ))}
      </div>
    );
  };

  onCellClicked = () => {
    if (!this.gridApi) return;
    const selectedRowNode = this.gridApi.getSelectedNodes()[0];
    const seqValue = selectedRowNode.data.seqNumber;
    this.navigateToShipmentDetails({ ...selectedRowNode.data, seq: seqValue });
  };

  navigateToShipmentDetails = (selectedShipment) => {
    const params = this.getUpdatedURLParams(selectedShipment);
    const state = this.constructRouterState(selectedShipment);
    this.props.router.navigate(`?${params.toString()}`, { state });
  };

  getUpdatedURLParams = (selectedShipment) => {
    const params = new URLSearchParams(location.search);
    params.set('proId', selectedShipment.proId);
    params.set('seq', selectedShipment.seq);
    params.set('isPickupPro', true);
    return params;
  };

  freightDescriptionDetails = ({ freightDescriptionDetails, packageCode, hu }) => {
    if (this.isPickupCompleted()) {
      return freightDescriptionDetails;
    }
    return [{ packageCode, hu }];
  };

  /* Ensure that the previous state data (this.props.pickInfoStateData) is passed to the Pro Info Drawer when both 
     the Pickup Info Drawer and Pickup Info Popup are opened together, as the current navigation state is shared between both components. 
  */
  constructRouterState = (selectedShipment) => ({
    ...this.props.pickInfoStateData,
    isResized: true,
    proDetails: {
      ...selectedShipment,
      hazmatInfo: selectedShipment.hazardousShipmentDetail,
      freightDescriptionDetails: this.freightDescriptionDetails(selectedShipment)
    }
  });

  render() {
    const { classes, gridInfo } = this.props;
    const data = gridInfo?.data?.length > 0 ? gridInfo.data.slice() : [];
    return (
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          onCellClicked={this.onCellClicked}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={data}
          onGridReady={this.onGridReady}
          layoutContainer={this.props.glContainer}
          panelLabel={this.constructStatusBar}
          showErrorMessage={gridInfo.gridStatus}
          context={this.gridContext}
        />
      </div>
    );
  }
}
export default compose(withAppConfig, withStyles(styles), withRouter)(PickupInfoGrid);
